import React from "react";
import { FaGithub, FaLinkedin, FaFacebook, FaWhatsapp,FaInstagram } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          LinkedIn <FaLinkedin size={30} />
        </>
      ),
      href: "https://www.linkedin.com/in/smith-mallick-ba8065132/",
      style: "rounded-tr-md",
    },
    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={30} />
        </>
      ),
      href: "https://github.com/smithmallick149",
    },
    {
      id: 3,
      child: (
        <>
          EMail <HiOutlineMail size={30} />
        </>
      ),
      href: "mailto:smithmallickjbn@gmail.com",
    },
    {
      id: 4,
      child: (
        <>
          Resume <BsFillPersonLinesFill size={30} />
        </>
      ),
      href: "/Smith_Frontend_Resume.pdf",
      download: true,
    },
    {
      id: 5,
      child: (
        <>
          Instagram <FaInstagram size={30} />
        </>
      ),
      href: "https://www.instagram.com/s_m_i_t_h_7/?hl=en",
    },
    {
      id:6,
      child:(
        <>
        Facebook <FaFacebook size={30} />
      </>
      ),
      // href:"https://www.facebook.com/smith.mallick.9/",
      href:"https://m.me/smith.mallick.9",

    },
    {
      id:7,
      child:(
        <>
        Whatsapp <FaWhatsapp size={30} />
      </>
      ),
      href:"https://web.whatsapp.com/send?phone= [+917504786353]",
      style: "rounded-br-md",

    }
  ];

  return (
    <div className="hidden lg:flex flex-row top-[35%] left-0 fixed inline">
      <ul>
        {links.map(({ id, child, href, style, download }) => (
          <li
            key={id}
            className={
              "flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-200 bg-gray-500" +
              " " +
              style
            }
          >
            <a
              href={href}
              className="flex justify-between items-center w-full text-white"
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;